"use strict";

import { NativeModules, Platform, Linking } from 'react-native';
import { _ensureNativeModuleIsInitializedWithConfiguration } from '../utils/nativeHelper';
const A0Auth0 = NativeModules.A0Auth0;
class Agent {
  async login(parameters, options, localAuthenticationOptions) {
    let linkSubscription = null;
    if (!NativeModules.A0Auth0) {
      return Promise.reject(new Error('Missing NativeModule. React Native versions 0.60 and up perform auto-linking. Please see https://github.com/react-native-community/cli/blob/master/docs/autolinking.md.'));
    }
    return new Promise(async (resolve, reject) => {
      if (Platform.OS === 'ios') {
        linkSubscription = Linking.addEventListener('url', async event => {
          try {
            linkSubscription?.remove();
            await A0Auth0.resumeWebAuth(event.url);
          } catch (error) {
            reject(error);
          }
        });
      }
      try {
        await _ensureNativeModuleIsInitializedWithConfiguration(A0Auth0, parameters.clientId, parameters.domain, localAuthenticationOptions);
        let scheme = this.getScheme(options.useLegacyCallbackUrl ?? false, options.customScheme);
        let redirectUri = options.redirectUrl ?? this.callbackUri(parameters.domain, scheme);
        let credentials = await A0Auth0.webAuth(scheme, redirectUri, options.state, options.nonce, options.audience, options.scope, options.connection, options.maxAge ?? 0, options.organization, options.invitationUrl, options.leeway ?? 0, options.ephemeralSession ?? false, options.safariViewControllerPresentationStyle ?? 99,
        //Since we can't pass null to the native layer, and we need a value to represent this parameter is not set, we are using 99.
        //The native layer will check for this and ignore if the value is 99
        options.additionalParameters ?? {});
        resolve(credentials);
      } catch (error) {
        linkSubscription?.remove();
        reject(error);
      }
    });
  }
  async cancelWebAuth(parameters, localAuthenticationOptions) {
    if (!NativeModules.A0Auth0) {
      return Promise.reject(new Error('Missing NativeModule. React Native versions 0.60 and up perform auto-linking. Please see https://github.com/react-native-community/cli/blob/master/docs/autolinking.md.'));
    }
    await _ensureNativeModuleIsInitializedWithConfiguration(NativeModules.A0Auth0, parameters.clientId, parameters.domain, localAuthenticationOptions);
    return A0Auth0.cancelWebAuth();
  }
  async logout(parameters, options, localAuthenticationOptions) {
    if (!NativeModules.A0Auth0) {
      return Promise.reject(new Error('Missing NativeModule. React Native versions 0.60 and up perform auto-linking. Please see https://github.com/react-native-community/cli/blob/master/docs/autolinking.md.'));
    }
    let federated = options.federated ?? false;
    let scheme = this.getScheme(options.useLegacyCallbackUrl ?? false, options.customScheme);
    let redirectUri = options.returnToUrl ?? this.callbackUri(parameters.domain, scheme);
    await _ensureNativeModuleIsInitializedWithConfiguration(NativeModules.A0Auth0, parameters.clientId, parameters.domain, localAuthenticationOptions);
    return A0Auth0.webAuthLogout(scheme, federated, redirectUri);
  }
  getScheme(useLegacyCustomSchemeBehaviour, customScheme) {
    let scheme = NativeModules.A0Auth0.bundleIdentifier.toLowerCase();
    if (!useLegacyCustomSchemeBehaviour) {
      scheme = scheme + '.auth0';
    }
    return customScheme ?? scheme;
  }
  callbackUri(domain, scheme) {
    let bundleIdentifier = NativeModules.A0Auth0.bundleIdentifier.toLowerCase();
    return `${scheme}://${domain}/${Platform.OS}/${bundleIdentifier}/callback`;
  }
}
export default Agent;
//# sourceMappingURL=agent.js.map